import { FiPlusCircle as _FiPlusCircle } from "@react-icons/all-files/fi/FiPlusCircle.js";
import { FiMinusCircle as _FiMinusCircle } from "@react-icons/all-files/fi/FiMinusCircle.js";
import React from 'react';
import { Flex, Icon, Text } from 'core/components';
const FilterDisplayHeader = ({
  excluded = false,
  children
}) => /*#__PURE__*/React.createElement(Flex, {
  alignItems: "center",
  fontSize: "small"
}, /*#__PURE__*/React.createElement(Icon, {
  color: excluded ? 'danger' : 'success',
  icon: excluded ? _FiMinusCircle : _FiPlusCircle,
  mr: "4px"
}), /*#__PURE__*/React.createElement(Text, {
  color: "muted"
}, children));
export default FilterDisplayHeader;